import React, { useEffect } from "react"
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import * as R from 'ramda'
import moment from 'moment'

// import PartyLogin from '../components/PartyLogin'
// import PartyCompetition from '../components/PartyCompetition'
// import PartyComplete from '../components/PartyComplete'

import { connect } from 'react-redux'
import { getParty, checkJoined } from '../actions/party'

import { Row, Spin } from 'antd'

export function Party(props) {
    const history = useHistory()
    const { search } = useLocation()
    const partyId = queryString.parse(search).partyId
    const token = window.atob((queryString.parse(search).t))
    const nickname = decodeURI(queryString.parse(search).nickname)
    const invite = queryString.parse(search).invite

    useEffect(() => {
        props.getParty(partyId)
    }, [partyId])

    useEffect(() => {
        if (token) {
            sessionStorage.setItem('t', token)
        }
    }, [token])

    useEffect(() => {
        if (sessionStorage.getItem('t')) {
            props.checkJoined(partyId)
        }
    }, [sessionStorage.getItem('t')])

    useEffect(() => {
        if (R.and(props.isCheckingFinish, !R.isNil(props.partyInfo.end))) {            
            if (!props.checked) {
                history.replace(encodeURI(`/party/login?nickname=${nickname || 'FitGames用戶'}&invite=${invite || true}&end=${moment().isAfter(props.partyInfo.end * 1000, 'day')}`))
            } else {
                if (moment().isAfter(props.partyInfo.end * 1000, 'day')) {
                    history.replace(`/party/certificate`)
                } else {
                    history.replace(`/party/upload`)
                }

            }
        }
    }, [props.isCheckingFinish, props.partyInfo.end])

    return (
        <div className="party-setting">
            <div className="party">
                <Row type="flex" justify="center" align="middle" style={{ width: "100vw", height: "100vh", backgroundColor: "#CCE7ED" }}>
                    <Spin tip="Loading..." />
                </Row>

                {/* <PartyLogin /> */}

                {/* <PartyCompetition /> */}

                {/* <PartyComplete /> */}
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    partyInfo: state.party.partyInfo,
    isCheckingFinish: state.party.isCheckingFinish,
    checked: state.party.checked,
})

const mapDispatchToProps = {
    getParty,
    checkJoined,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Party)